<h5 class="text-primary-text">Date & time</h5>
<div class="border-1 border-solid rounded-lg p-12">
  <div class="flex flex-row gap-8 mb-12 font-semibold text-base">Timezone</div>

  <p>
    Select how timestamps are displayed across the platform. This setting applies to all storages in your portfolio. You can
    select a specific time zone, display times in each storage's local time, or use your browser's time.
  </p>

  <p class="mb-8">Timezone</p>

  <nz-select nzShowSearch [(ngModel)]="selectedTimeZone" class="w-full">
    @for (timezone of flatTimezones; track timezone.name) {
      <nz-option nzCustomContent [nzDisabled]="timezone.isGroupDivider" [nzValue]="timezone.value" [nzLabel]="timezone.name">
        <div class="flex flex-row gap-8">
          <span>{{ timezone.name }}{{ timezone.isGroupDivider ? '' : ',' }}</span>
          <span class="text-tertiary-text">{{ timezone.offset }}</span>
        </div>
      </nz-option>
    }
  </nz-select>

  @if (selectedTimeZone !== CustomUserTimezone.STORAGE_TIME) {
    <nz-alert
      class="mt-12"
      nzType="warning"
      nzShowIcon
      nzIconType="warning"
      nzMessage="Daily aggregates (e.g. on the recoverable energy page) are not affected by this setting. They are always calculated and displayed in each storage's local time zone."
    ></nz-alert>
  }

  <div class="mt-16 w-full flex justify-end">
    <button nz-button nzType="primary" (click)="save()" [nzLoading]="loading">Save</button>
  </div>
</div>
